import React from 'react';

import { Segmented } from 'antd';

import styled from 'styled-components';

import NwIcon from '@components/Gui/NwIcon';

import { BOOKS_CHARACTERISTIC_FILTERS } from './modelDetailsBooks.utils';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const StyledSegmented = styled(Segmented)`
    .characteristic-option {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 1.25rem;
        line-height: 1;
    }

    .characteristic-option-text {
        font-size: 0.75rem;
        font-weight: 600;
        text-transform: uppercase;
    }

    .characteristic-option-icon {
        font-size: 1rem;
        line-height: 0;
    }

    .ant-segmented-item-selected {
        .characteristic-option-icon,
        .characteristic-option-text {
            color: ${(props) => props.theme.PrimaryColor};
        }
    }
`;

const getCharacteristicOptions = () => [
    {
        label: (
            <span className="characteristic-option" title="all books">
                <span className="characteristic-option-text">all</span>
            </span>
        ),
        value: BOOKS_CHARACTERISTIC_FILTERS.ALL,
    },
    {
        label: (
            <span className="characteristic-option" title="published books">
                <span className="characteristic-option-icon">
                    <NwIcon icon={byPrefixAndName.fasl['globe']} />
                </span>
            </span>
        ),
        value: BOOKS_CHARACTERISTIC_FILTERS.PUBLISHED,
    },
    {
        label: (
            <span className="characteristic-option" title="fast package books">
                <span className="characteristic-option-icon">
                    <NwIcon icon={byPrefixAndName.fasl['truck-fast']} />
                </span>
            </span>
        ),
        value: BOOKS_CHARACTERISTIC_FILTERS.FAST_PACKAGE,
    },
    {
        label: (
            <span className="characteristic-option" title="comp card books">
                <span className="characteristic-option-icon">
                    <NwIcon icon={byPrefixAndName.fasl['image-polaroid-user']} />
                </span>
            </span>
        ),
        value: BOOKS_CHARACTERISTIC_FILTERS.COMP_CARD,
    },
    {
        label: (
            <span className="characteristic-option" title="my favourite books">
                <span className="characteristic-option-icon">
                    <NwIcon icon={byPrefixAndName.fasl['heart']} />
                </span>
            </span>
        ),
        value: BOOKS_CHARACTERISTIC_FILTERS.FAVOURITE,
    },
];

const ModelDetailsBooksCharacteristicsFilter = ({ value, onChange }) => {
    return <StyledSegmented options={getCharacteristicOptions()} value={value} onChange={onChange} />;
};

export default ModelDetailsBooksCharacteristicsFilter;
